import classnames from 'classnames';
import Raven from 'raven-js';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Card,
    Container,
    Nav, NavItem, NavLink,
    TabContent, TabPane
} from 'reactstrap';
import ApplicationDisplay from "../../../components/application/ApplicationDisplay";
import TUCreditDisplay from '../../../components/application/credit/TUCreditDisplay';
import TUCriminalDisplay from '../../../components/application/credit/TUCriminalDisplay';
import PolyUtil from "../../../util/PolyUtil";
import PoliceIncidentsDisplay from "./PoliceIncidentsDisplay";
import ReferenceDisplay from "./ReferenceDisplay";


// import test from '../../../util/test_data/tu_report2.json';
// import test from '../../../util/test_data/tu_report.json';

class OwnerApplicationView extends Component {
    state = {
        activeTab: '1',
        creditReport: null,
        criminalReport: null,
    };

    componentWillMount() {
        const {propId, roommate} = this.props;

        PolyUtil.fetchWrapper('/api/credit/reports/credit/' + roommate.id + '/' + propId + '/',
            {method: 'GET'}
        ).then((data) => {
            this.setState({creditReport: data.report});
        }).catch((error) => {
            this.setState({creditReport: null});
            Raven.captureException(error);
        });

        PolyUtil.fetchWrapper('/api/credit/reports/criminal/' + roommate.id + '/' + propId + '/',
            {method: 'GET'}
        ).then((data) => {
            this.setState({criminalReport: data.report});
        }).catch((error) => {
            this.setState({criminalReport: null});
            Raven.captureException(error);
        });
    }

    setActiveTab = (tab) => {
        this.state.activeTab !== tab && this.setState({activeTab: tab});
    };

    render() {
        const {roommate, roommate: {application}} = this.props;

        let incidents = [];
        roommate.application.rental_history_rentals.forEach((rental) => {
            if (rental.incidents.length !== 0) {
                rental.incidents.forEach((incident) => {
                    incidents.push(incident);
                });
            }
        });


        return (
            <Container fluid>
                <h2>{roommate.get_first_name + " " + roommate.get_last_name}</h2>
                <Nav>
                    <NavItem>
                        <NavLink onClick={() => this.setActiveTab('1')} className={classnames({'nav-tab-active': this.state.activeTab === '1'})}>Application</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink onClick={() => this.setActiveTab('2')} className={classnames({'nav-tab-active': this.state.activeTab === '2'})}>References</NavLink>
                    </NavItem>
                    {
                        incidents.length > 0 && (
                            <NavItem>
                                <NavLink onClick={() => this.setActiveTab('3')} className={classnames({'nav-tab-active': this.state.activeTab === '3'})}>Police Incidents</NavLink>
                            </NavItem>
                        )
                    }
                    <NavItem>
                        <NavLink onClick={() => this.setActiveTab('4')} className={classnames({'nav-tab-active': this.state.activeTab === '4'})}>Credit Report</NavLink>
                    </NavItem>
                    {
                        !roommate.application.guarantor && (
                            <NavItem>
                                <NavLink onClick={() => this.setActiveTab('5')} className={classnames({'nav-tab-active': this.state.activeTab === '5'})}>Criminal Record</NavLink>
                            </NavItem>
                        )
                    }
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                        <ApplicationDisplay application={application} noName/>
                    </TabPane>
                    <TabPane tabId="2">
                        <ReferenceDisplay rentalHistory={application.rental_history_rentals}/>
                    </TabPane>
                    <TabPane tabId="3">
                        <PoliceIncidentsDisplay incidents={incidents}/>
                    </TabPane>
                    <TabPane tabId="4">
                        <TUCreditDisplay report={this.state.creditReport} guarantor={roommate.application.guarantor}/>
                    </TabPane>
                    <TabPane tabId="5">
                        <TUCriminalDisplay report={this.state.criminalReport} guarantor={roommate.application.guarantor}/>
                    </TabPane>
                    <TabPane tabId="10">
                        <Card body className="pr-card">
                            <h2 className="text-danger">Uh oh!</h2>
                            <p>There was a problem getting this tenant's credit report from TransUnion. Don't worry, we're working to fix it ASAP!</p>
                        </Card>
                    </TabPane>
                </TabContent>


            </Container>
        );
    }
}

export default connect()(OwnerApplicationView);



// WEBPACK FOOTER //
// ./src/containers/owner/applications/OwnerApplicationView.js